import { isFromApp } from '@shared/helpers/isFromApp'

const openExternalUrl = (url) => {
  url = typeof url === 'string' ? url : ''

  if (!url) {
    return Promise.reject(url)
  }

  const link = document.createElement('a')
  link.setAttribute('href', url)

  if (isFromApp()) {
    link.setAttribute('target', '_self')
  } else {
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener')
  }

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  return Promise.resolve(url)
}

export default openExternalUrl
